<ng-container *ngIf="isHamburgerMenuItem">
  <button mat-menu-item (click)="onLeaveGame()">
    <mat-icon>logout</mat-icon>
    <span>{{ leaveGameButtonLabel }}</span>
  </button>
</ng-container>

<ng-container *ngIf="!isHamburgerMenuItem">
  <button mat-stroked-button (click)="onLeaveGame()">
    {{ leaveGameButtonLabel }}
  </button>
</ng-container>
